import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CoreComponent } from '../core/core.component.js';

export type InfoTableItem = {
	readonly title: string;
	readonly value: string | undefined;
	readonly valueClick?: () => void;
};

@Component({
	selector: 'ui-info-table',
	templateUrl: './info-table.component.html',
	styleUrls: ['./info-table.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class InfoTableComponent extends CoreComponent {
	public readonly items = input.required<readonly InfoTableItem[]>();
	public readonly hideEmptyItems = input<boolean>(false);

	protected readonly filteredItems = computed<readonly InfoTableItem[]>(() => {
		return this.items().filter((m) => {
			if (this.hideEmptyItems()) {
				return m.value !== undefined && m.value !== null && m.value !== '';
			}
			return true;
		});
	});
}
